import { Media } from 'media'
import { ComponentType } from 'react'
import { MapDesktop } from './map-desktop'
import { MapMobile } from './map-mobile'

export const Map: ComponentType<{
  suptitle: string
  title: string
  properties: any[]
  total: number
  page: number
  limit: number
  loading: boolean
}> = ({ suptitle, title, properties, total, page, limit, loading }) => (
  <>
    <Media at="xs">
      <MapMobile properties={properties} />
    </Media>
    <Media greaterThan="xs">
      <MapDesktop
        suptitle={suptitle}
        title={title}
        properties={properties}
        total={total}
        page={page}
        limit={limit}
        loading={loading}
      />
    </Media>
  </>
)
